import { apiPublicGetOne, apiPublicPost } from "../../../core/services";

export const getQuoteSteps = async (quoteId) => {
  return await apiPublicGetOne(`/quotes/${quoteId}/steps`);
};

export const getQuote = async (quoteId) => {
  return await apiPublicGetOne(`/quotes/${quoteId}`);
};

export const createQuote = async (basketId) => {
  return await apiPublicPost("/quotes/basket/" + basketId, {});
};
